import { allEnumValues, FulfillmentMethod, UserRight, Weekday } from '@biteinc/enums';
import { SyncableMenuModelSchema } from './syncable_menu_model_schema.js';
export const openHoursTimetableSchema = {
    displayName: 'open hours',
    type: 'object',
    fields: {
        ...SyncableMenuModelSchema.fields,
        siteId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'keyString',
            isHidden: true,
            isReadOnly: true,
        },
        fulfillmentMethod: {
            type: 'int',
            values: allEnumValues(FulfillmentMethod),
            required: true,
            isHidden: true,
        },
        daySchedules: {
            writeRight: UserRight.ManageOpenHours,
            type: 'array',
            elementType: 'object',
            fields: {
                weekday: {
                    type: 'stringEnum',
                    enum: Weekday,
                    required: true,
                    isHidden: true,
                },
                schedules: {
                    displayName: 'Schedules',
                    type: 'array',
                    elementType: 'object',
                    elementSubtype: 'Schedule',
                    required: true,
                    minCount: 1,
                },
            },
        },
    },
};
//# sourceMappingURL=open_hours_timetable_schema.js.map